import { createFileRoute } from '@tanstack/react-router'

import { CampaignDetailConsolePage } from '#/modules/campaigns/campaign-detail-page'
import { validateCampaignDetailSearch } from '#/pages/campaign'
import type { CampaignDetailSearch } from '#/pages/campaign'

type Search = CampaignDetailSearch & { view?: 'console' }

export const Route = createFileRoute('/_shell/campaign/$campaignId')({
  component: CampaignDetailRoute,
  validateSearch: (search: Record<string, unknown>): Search => ({
    ...validateCampaignDetailSearch(search),
    ...(search['view'] === 'console' ? { view: 'console' as const } : {}),
  }),
})

function CampaignDetailRoute() {
  const { campaignId } = Route.useParams()
  const { view } = Route.useSearch()
  return (
    <CampaignDetailConsolePage
      campaignId={campaignId}
      view={view === 'console' ? 'console' : 'product'}
    />
  )
}
